import { render, staticRenderFns } from "./WQCheckBaseStandardForm.vue?vue&type=template&id=230a3160"
import script from "./WQCheckBaseStandardForm.vue?vue&type=script&lang=js"
export * from "./WQCheckBaseStandardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports